var _rect, _rect2, _rect3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMobiliario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20829",
    "data-name": "Group 20829",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.057,
    height: 58.044,
    viewBox: "0 0 57.057 58.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 22.451,
    height: 22.451,
    rx: 0.726,
    transform: "translate(0 0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 22.451,
    height: 22.451,
    rx: 0.726,
    transform: "translate(25.852 0)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 22.451,
    height: 22.451,
    rx: 0.726,
    transform: "translate(0 26.533)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M133.723,88.329a2.841,2.841,0,0,1,2.252,1.119l2.133,2.813V86.494a.494.494,0,0,0-.494-.494H116.152a.494.494,0,0,0-.495.494v21.463a.494.494,0,0,0,.495.494H128.7L130.918,90.8A2.832,2.832,0,0,1,133.723,88.329Z",
    transform: "translate(-89.807 -59.467)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M145.282,99.138l-4.3-5.674a.106.106,0,0,0-.189.051l-2.176,17.308-.514,4.094a.106.106,0,0,0,.1.119.1.1,0,0,0,.044-.01l5.987-2.723a.112.112,0,0,1,.044-.01.106.106,0,0,1,.1.078l1.993,7.437a.106.106,0,0,0,.1.078.094.094,0,0,0,.027,0l2.715-.727a.105.105,0,0,0,.074-.129L147.3,111.59a.106.106,0,0,1,.092-.133l6.547-.634a.106.106,0,0,0,.074-.169Z",
    transform: "translate(-96.979 -61.843)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobiliario);
export default __webpack_public_path__ + "static/media/icon_mobiliario.ee7615084d159db4ed0f794803c793b0.svg";
export { ForwardRef as ReactComponent };